import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router, { guardedChunkReload } from './router'
import './style.css'
import './charts/echarts'
import App from './App.vue'
import { reportError } from './error-tracking'

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.config.errorHandler = (err, _instance, info) => {
  reportError(err as Error, { vueInfo: info })
  console.error(err)
}

window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason instanceof Error ? event.reason : new Error(String(event.reason))
  reportError(error, { type: 'unhandledrejection' })
})

app.mount('#app')

window.addEventListener('vite:preloadError', () => {
  guardedChunkReload()
})

import { registerSW } from 'virtual:pwa-register'
registerSW({ immediate: true })
